import uniq from 'lodash.uniq';
import { alphaSorter } from 'vet-bones/utils';
import { ANY_CLASS_IRI } from 'vet-bones/utils/queryBuilder';

export const buildInequalityFilter = ({
  abbreviate,
  idsByIri,
  instancesById,
  variablesById,
  variableIds,
}: {
  abbreviate: (iri: string) => string;
  idsByIri: Record<string, Set<string>>;
  instancesById: Record<string, string>;
  variablesById: Record<string, string>;
  variableIds: Set<string>;
}) => {
  const inequalities: string[] = [];

  const anyClassIds = idsByIri[ANY_CLASS_IRI];
  Object.values(idsByIri).forEach((ids) => {
    const allIds = new Set(ids);
    if (anyClassIds) {
      anyClassIds.forEach((id) => {
        allIds.add(id);
      });
    }

    const allInstances: string[] = [];
    const allVariables: string[] = [];

    Array.from(allIds).forEach((id) => {
      if (!variableIds.has(id)) {
        return;
      }

      const instance = instancesById[id];
      if (instance) {
        allInstances.push(instance);
        return;
      }

      const variable = variablesById[id];
      if (variable) {
        allVariables.push(variable);
      }
    });

    const sortedInstances = uniq(allInstances).sort(alphaSorter);
    const sortedVariables = uniq(allVariables).sort(alphaSorter);

    // iterate through all possible pairs
    for (let i = 0; i < sortedVariables.length; i += 1) {
      sortedInstances.forEach((instanceIri) => {
        inequalities.push(
          `${sortedVariables[i]} != ${abbreviate(instanceIri)}`
        );
      });

      for (let j = i + 1; j < sortedVariables.length; j += 1) {
        if (sortedVariables[i] !== sortedVariables[j]) {
          inequalities.push(`${sortedVariables[i]} != ${sortedVariables[j]}`);
        }
      }
    }
  });

  return inequalities.length
    ? `FILTER(${inequalities.sort(alphaSorter).join(' && ')})`
    : '';
};
